import { useRouter } from 'next/router';

import { ServiceOSGlobalSettings } from '../utils/getServiceOSGlobalSettings';
import { getServiceOSPasswordResetQueryParams } from '../utils/getServiceOSPasswordResetQueryParams';

export function useServiceOSPasswordResetRedirects(
  serviceOSGlobalSettings: ServiceOSGlobalSettings
) {
  const router = useRouter();

  if (typeof window === 'undefined') {
    return;
  }

  if (`${router.locale}${router.asPath}`.includes(serviceOSGlobalSettings.changePasswordPageUrl)) {
    return;
  }

  const { searchParams } = getServiceOSPasswordResetQueryParams(serviceOSGlobalSettings);

  if (!searchParams) {
    return;
  }

  const url = new URL(serviceOSGlobalSettings.changePasswordPageUrl, window.location.origin);
  url.search = searchParams.toString();

  router.push(url.toString());
}
